<div class="h-full w-full">
  <router-outlet></router-outlet>
</div>
